'use strict'

import {slideDown, slideUp} from "../utils/slideToggle";

const GatedContent = {
    init: function () {
        const switcher = document.querySelector('.radio__ctn.choice--');
        if (switcher) {
            const radioButtons = document.getElementsByName('receive_type');
            if (radioButtons) {
                // Fonction pour gérer les champs requis
                const toggleRequiredFields = (isPostal) => {
                    const postalFields = document.querySelectorAll('.c-form__section[data-type="postal"] input, .c-form__section[data-type="postal"] select');

                    postalFields.forEach(field => {
                        if (isPostal) {
                            // Activer la validation pour l'envoi postal
                            field.setAttribute('required', 'true');
                        } else {
                            // Désactiver la validation pour le téléchargement
                            field.removeAttribute('required');
                            // Vider les valeurs pour éviter les conflits
                            field.value = '';
                        }
                    });
                };

                // Initialisation au chargement de la page
                const checkedRadio = document.querySelector('input[name="receive_type"]:checked');
                if (checkedRadio) {
                    const isPostal = checkedRadio.value.includes('postal') || checkedRadio.id === 'postal';
                    toggleRequiredFields(isPostal);

                    // Masquer/afficher la section selon le choix initial
                    const sections = document.querySelectorAll('.c-form__section[data-type="postal"]');
                    sections.forEach(section => {
                        if (!isPostal) {
                            section.style.display = 'none';
                        }
                    });
                }

                // Gestion des changements de sélection
                radioButtons.forEach(radio => {
                    radio.addEventListener('change', () => {
                        if (radio.checked) {
                            const isPostal = radio.value.includes('postal') || radio.id === 'postal';

                            // Gérer les champs requis
                            toggleRequiredFields(isPostal);

                            // Animer l'affichage/masquage des sections
                            let sections = document.querySelectorAll('.c-form__section[data-type="postal"]');
                            if (sections) {
                                sections.forEach(section => {
                                    if(isPostal){
                                        slideDown(section);
                                    } else {
                                        slideUp(section);
                                    }
                                });
                            }
                        }
                    });
                });
            }
        }
    }
}

export default GatedContent;